import { Typography } from "@suraasa/placebo-ui"
import { Assignment } from "api/resources/assignments/types"

import AssignmentDetailSheet from "./AssignmentDetailSheet"
import { isBlank } from "./utils"

type Props = {
  acs: NonNullable<Assignment["assignmentAssessmentCriteria"]>
  pedagogicalSkillEvaluated?: string | null
  open: boolean
  onClose: () => void
}

const LearningOutcomesSheet = ({
  acs,
  pedagogicalSkillEvaluated,
  open,
  onClose,
}: Props) => (
  <AssignmentDetailSheet
    title="Assessment Criteria (AC) and Learning Outcomes (LO)"
    open={open}
    onClose={onClose}
  >
    {acs.map((data, index) => (
      <div
        key={index}
        style={{ boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.05)" }}
        className="mb-2 rounded-[12px] border border-surface-200 bg-common-white-500 p-2"
      >
        <div className="mb-1 flex items-start">
          <Typography variant="strong" className="me-1 shrink-0">
            AC
          </Typography>
          <Typography>{data.name}</Typography>
        </div>
        <div className="flex items-start">
          <Typography variant="strong" className="me-1 shrink-0">
            LO
          </Typography>
          <Typography>{data.learningOutcome.name}</Typography>
        </div>
      </div>
    ))}

    {pedagogicalSkillEvaluated && !isBlank(pedagogicalSkillEvaluated) && (
      <div className="flex flex-col items-start rounded-xl border border-success-200 bg-success-100 p-1.5">
        <Typography className="mb-0.5 text-success-900" variant="title4">
          Pedagogical Skill Evaluated
        </Typography>
        <Typography variant="smallBody" className="text-success-900">
          {pedagogicalSkillEvaluated}
        </Typography>
      </div>
    )}
  </AssignmentDetailSheet>
)

export default LearningOutcomesSheet
